var map = {
	"./puzzle_1.png": "51ea",
	"./puzzle_10.png": "4180",
	"./puzzle_11.png": "26f8",
	"./puzzle_12.png": "a7b0",
	"./puzzle_13.png": "3fb8",
	"./puzzle_14.png": "4ad9",
	"./puzzle_15.png": "c8fb",
	"./puzzle_16.png": "fe18",
	"./puzzle_17.png": "65c2",
	"./puzzle_18.png": "9c63",
	"./puzzle_19.png": "d183",
	"./puzzle_2.png": "659b",
	"./puzzle_20.png": "67ea",
	"./puzzle_21.png": "62c7",
	"./puzzle_22.png": "8f14",
	"./puzzle_23.png": "1444",
	"./puzzle_24.png": "c864",
	"./puzzle_25.png": "adbf",
	"./puzzle_26.png": "1cbd",
	"./puzzle_27.png": "5094",
	"./puzzle_28.png": "fe5e",
	"./puzzle_29.png": "7a58",
	"./puzzle_3.png": "9fd2",
	"./puzzle_30.png": "afc3",
	"./puzzle_31.png": "6e75",
	"./puzzle_32.png": "719e",
	"./puzzle_33.png": "54060",
	"./puzzle_34.png": "f3083",
	"./puzzle_35.png": "3ab9",
	"./puzzle_36.png": "1d37",
	"./puzzle_37.png": "7da7",
	"./puzzle_4.png": "522b",
	"./puzzle_5.png": "72ae",
	"./puzzle_6.png": "58f7",
	"./puzzle_7.png": "5969",
	"./puzzle_8.png": "a357",
	"./puzzle_9.png": "d879"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6870";